import axios from "axios";

const buscarProductoServicio = async () => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${token}`,
        },
    };

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/productos/buscar-todo`,
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

const buscarProductoStockServicio = async () => {
    const token = localStorage.getItem("token");
    const config = {
        headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${token}`,
        },
    };

    try {
        const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/productos/stocks`,
            config
        );
        return [true, response.data];
    } catch (error) {
        return [false, error.status, error.response.data];
    }
}

export {
    buscarProductoServicio,
    buscarProductoStockServicio
}